import { cn } from "@/lib/utils";

interface QuickReplyChipsProps {
  chips: string[];
  onSelect: (chip: string) => void;
  className?: string;
}

export function QuickReplyChips({
  chips,
  onSelect,
  className,
}: QuickReplyChipsProps) {
  if (chips.length === 0) return null;
  return (
    <div className={cn("mt-3 flex flex-wrap gap-2", className)}>
      {chips.map((chip) => (
        <button
          key={chip}
          type="button"
          onClick={() => onSelect(chip)}
          className="rounded-full border border-border bg-background px-3 py-1 text-xs text-foreground transition-colors hover:border-brand/50 hover:bg-muted"
        >
          {chip}
        </button>
      ))}
    </div>
  );
}
